export enum AccountType  {
    COMPANY = "Company",
    PERSON = "Person",
    SUBLIME_EMPLOYEE = "Sublime employee"
}